import { p as prisma } from "../../../../../chunks/prisma.js";
const load = (async ({ params, depends }) => {
  const id = Number(params.id);
  try {
    const order = await prisma.order.findUnique({
      where: { id },
      include: {
        ProductOnOrder: {
          include: { product: true }
        },
        user: true
      }
    });
    if (!order) return { status: 404, error: "Order not found" };
    return { order };
  } catch (e) {
    console.log("getOrder:", e);
    return { status: 500, error: "Internal server error getting order details" };
  }
});
export {
  load
};
